import { useEffect, useState } from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import GlassInput from '../ui/GlassInput';
import Field from '../ui/Field';
import { updateTipoConcepto } from '../../services/tipoConceptos';

function validateName(value) {
  const trimmed = value.trim();
  if (!trimmed) return 'El nombre del tipo de concepto es obligatorio.';
  if (trimmed.length < 2) return 'Debe tener al menos 2 caracteres.';
  if (trimmed.length > 100) return 'Máximo 100 caracteres.';
  return null;
}

function ActualizarTipoConceptoModal({ isOpen, onClose, item, onUpdated }) {
  const [name, setName] = useState('');
  const [touched, setTouched] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    if (isOpen && item) {
      setName(item.deTipoConcepto ?? '');
      setTouched(false);
      setFeedback(null);
    }
  }, [isOpen, item]);

  const error = touched ? validateName(name) : null;

  const handleClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validation = validateName(name);
    setTouched(true);
    if (validation) {
      setFeedback({ type: 'error', message: validation });
      return;
    }

    setIsSubmitting(true);
    setFeedback(null);
    try {
      const result = await updateTipoConcepto(item.tpConcepto, name.trim());
      if (result.ok) {
        setFeedback({
          type: 'success',
          message: 'Se actualizó el Tipo Concepto con éxito.',
        });
        onUpdated?.(result.data);
      } else {
        setFeedback({
          type: 'error',
          message: 'Error en el proceso de gestión de Tipo Concepto.',
        });
      }
    } catch {
      setFeedback({
        type: 'error',
        message: 'Error de conexión. Verifica tu red e intenta nuevamente.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Actualizar tipo de concepto"
      description="Modifica el nombre del tipo de concepto"
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit} isLoading={isSubmitting}>
            {isSubmitting ? 'Guardando…' : 'Guardar cambios'}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit} noValidate className="space-y-4">
        <Field
          label="Nombre del Tipo Concepto"
          required
          htmlFor="update-de-tipo-concepto"
          error={touched ? error : undefined}
        >
          <GlassInput
            id="update-de-tipo-concepto"
            label="Nombre del Tipo Concepto"
            value={name}
            onChange={(event) => {
              setName(event.target.value);
              if (feedback) setFeedback(null);
            }}
            onBlur={() => setTouched(true)}
            isInvalid={Boolean(touched && error)}
            maxLength={100}
          />
        </Field>
        {feedback && (
          <div
            role="status"
            className={`flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm animate-fade-up ${feedback.type === 'success' ? 'border-emerald-300/30 bg-emerald-300/[0.06] text-emerald-100' : 'border-rose-300/30 bg-rose-300/[0.06] text-rose-100'}`}
          >
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/10 text-[11px] font-bold">
              {feedback.type === 'success' ? '✓' : '!'}
            </span>
            <p className="text-sm">{feedback.message}</p>
          </div>
        )}
      </form>
    </Modal>
  );
}

export default ActualizarTipoConceptoModal;